import Relay from 'react-relay';

export default {
  viewer: () => Relay.QL`query { agents }`
};



/** WEBPACK FOOTER **
 ** ./src/queries/AgentQuery.js
 **/